<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-7">
        <article class="panel">
          <p class="panel-heading">
            Reliant Configuration
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" placeholder="Required" maxlength="128">
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="ApiKey">
              <div class="control">
                <input formControlName="ApiKey" class="input" [placeholder]="!this.ModelIsNew ? 'API key hidden for security - leave blank to keep existing key' : 'Required'" maxlength="128" placeholder="">
                <app-validator [For]="Form.get('ApiKey')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Url">
              <div class="control">
                <input formControlName="Url" class="input" placeholder="Required" maxlength="128">
                <app-validator [For]="Form.get('Url')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="input" placeholder="" maxlength="2048"></textarea>
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}
